import { ReactNode, useEffect } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { applyTheme } from '../utils/theme';
import '../presenca.css';

/** Loads the presence styles and applies the client's brand color. */
export function PresenceTheme({ children }: { children: ReactNode }) {
  const { client } = useAuth();
  useEffect(() => {
    applyTheme(client?.primaryColor);
  }, [client?.primaryColor]);
  return <>{children}</>;
}
